import { render, staticRenderFns } from "./Screenshot.vue?vue&type=template&id=c1c3135e"
import script from "./Screenshot.vue?vue&type=script&lang=js"
export * from "./Screenshot.vue?vue&type=script&lang=js"
import style0 from "./Screenshot.vue?vue&type=style&index=0&id=c1c3135e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports